import { OPEN_TERMS_MODAL, CLOSE_TERMS_MODAL } from '../actions/actionTypes';

const initialState: {opened: boolean, informativeMode?: boolean} = {opened: false};

export const termsAndConditionsModalReducer = (state: {opened: boolean} = initialState, action: any) => {
  switch (action.type) {
    case OPEN_TERMS_MODAL:
      return {
        informativeMode: action.informativeMode,
        opened: true
      }; 
    case CLOSE_TERMS_MODAL:
      return {
        ...state,
        opened: false
      }; 
    default:
      return state;
  }
};
